import type ModuleButtonsType from '../components/ModuleButtonsType';
import { showDeleteDialog, showDetailsReportingDialog, Utils } from 'app/main/components';
import { showAddNotesDialog } from 'app/main/submodules/notes/NotesAddDialog';
import { shareDetailsPage } from 'app/main/components/dialogs/ShareDialog';
import { showFastAddDialog } from '../components/FastAddDialog';
import { showGroupsUsersAddDialog } from './groups-users/GroupsUsersAddDialog';

const buttons: ModuleButtonsType = {
	view: {
		itemButtons: [
			// {
			// 	name: 'VIEW_ITEM_BUTTON_FAVOURITE',
			// 	icon: 'star-outline',
			// 	disabled: () => true,
			// 	action: () => {}
			// },
			{
				name: 'VIEW_ITEM_BUTTON_EDIT',
				icon: 'edit',
				hidden: ({ authorizer }) => authorizer.cannot('update', 'groups'),
				action: ({ dispatch, updateRefresh, model }) =>
					dispatch(showFastAddDialog({ module: 'groups', updateRefresh, isUpdate: true, model }))
			},

			{
				name: 'VIEW_HEADER_BUTTON_NEW_USER',
				icon: 'account',
				iconAdd: true,
				hidden: ({ authorizer }) => authorizer.cannot('update', 'groups'),
				action: ({ model, dispatch, updateRefresh }) =>
					dispatch(showGroupsUsersAddDialog({ model, updateRefresh }))
			},
			{
				name: 'VIEW_ITEM_BUTTON_NEW_NOTE',
				icon: 'comment-text-multiple-outline',
				iconAdd: true,
				action: ({ model, dispatch }) =>
					dispatch(showAddNotesDialog({ model: { note_table: 'groups', note_table_uid: model.grps_uid } }))
			},
			{
				name: 'VIEW_ITEM_BUTTON_DELETE',
				icon: 'delete',
				hidden: ({ authorizer }) => authorizer.cannot('delete', 'groups'),
				action: ({ model, dispatch, updateRefresh }) =>
					dispatch(
						showDeleteDialog({
							module: 'groups',
							id: model.grps_uid,
							title: model.grps_title,
							updateRefresh
						})
					)
			}
		],
		headerButtons: [
			{
				name: 'VIEW_HEADER_BUTTON_NEW',
				icon: 'plus-circle',
				hidden: ({ authorizer }) => authorizer.cannot('create', 'groups'),
				action: () => Utils.openLink({ pathname: '/groups/add' })
			}
		]
	},
	details: {
		headerButtons: [
			// {
			// 	name: 'DETAILS_HEADER_BUTTON_FAVOURITE',
			// 	icon: 'star-outline',
			// 	disabled: () => true,
			// 	action: () => {}
			// },
			{
				name: 'DETAILS_HEADER_BUTTON_EXPORT',
				icon: 'file-export',
				hidden: ({ authorizer }) => authorizer.cannot('export', 'groups'),
				action: ({ model, dispatch, settings, sysSettings }) =>
					showDetailsReportingDialog({ model, dispatch, settings, sysSettings })
			},
			{
				name: 'DETAILS_HEADER_BUTTON_SHARE',
				icon: 'share-variant',
				action: ({ model, dispatch, settings, t }) => shareDetailsPage({ model, dispatch, settings, t })
			},
			{
				name: 'DETAILS_HEADER_BUTTON_SHOW_LOG',
				icon: 'timeline-clock-outline',
				disabled: ({ isEdit }) => isEdit,
				hidden: ({ authorizer }) => authorizer.cannot('view', 'logs'),
				action: ({ switchShowLogs }) => switchShowLogs()
			},
			{
				name: 'DETAILS_HEADER_BUTTON_DELETE',
				icon: 'delete',
				hidden: ({ authorizer }) => authorizer.cannot('delete', 'groups'),
				action: ({ model, dispatch }) =>
					dispatch(
						showDeleteDialog({
							module: 'groups',
							id: model.grps_uid,
							title: model.grps_title
						})
					)
			}
		],
		fabs: [
			{
				id: 'summary',
				name: 'ACTION_EDIT',
				icon: 'edit',
				hidden: ({ authorizer }) => authorizer.cannot('update', 'groups'),
				action: ({ switchEdit }) => switchEdit()
			},
			{
				id: 'users',
				name: 'VIEW_HEADER_BUTTON_NEW_USER',
				icon: 'account',
				iconAdd: true,
				hidden: ({ authorizer }) => authorizer.cannot('update', 'groups'),
				action: ({ model, dispatch, updateRefresh }) =>
					dispatch(showGroupsUsersAddDialog({ model, updateRefresh }))
			},
			{
				id: 'communications',
				name: 'DETAILS_HEADER_BUTTON_NEW_COMMUNICATION',
				icon: 'newspaper-variant',
				iconAdd: true,
				hidden: ({ isModuleDisabled, authorizer }) =>
					isModuleDisabled('communications') || authorizer.cannot('create', 'communications'),
				action: ({ model, dispatch, updateRefresh }) =>
					dispatch(
						showFastAddDialog({
							module: 'communications',
							updateRefresh,
							model: {
								coms_visibility: 'GROUP',
								coms_grps_uid: model.grps_uid,
								grps_title: model.grps_title
							}
						})
					)
			},
			{
				id: 'documents-folders',
				name: 'DETAILS_HEADER_BUTTON_NEW_SYS_DOCUMENTS_FOLDER',
				icon: 'folder-multiple',
				iconAdd: true,
				hidden: ({ isModuleDisabled, authorizer }) =>
					isModuleDisabled('sys_documents_folders') || authorizer.cannot('create', 'sys_documents_folders'),
				action: ({ model, dispatch, updateRefresh }) =>
					dispatch(
						showFastAddDialog({
							module: 'sys_documents_folders',
							updateRefresh,
							model: {
								fold_visibility: 'GROUP',
								fold_grps_uid: model.grps_uid,
								grps_title: model.grps_title
							}
						})
					)
			}
		]
	}
};

export default buttons;
